<template id="template-select">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    class="text-left"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :label="label"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <!-- preview tab -->
    <b-collapse
      :class="isPreview ? 'mt-0 mb-3' : 'mt-5'"
      id="collapse-1"
      v-model="collapse"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional == '1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <label class="ml-2">
          <span
            v-if="
              fieldData.validation &&
                fieldData.validation.requiredFirstSelect == 1
            "
            class="required-span"
            >*</span
          >
          {{
            form1.enableSectionFieldEnumeration == 1
              ? sectionIndex + 1 + "." + (fieldIndex + 1)
              : ""
          }}
          {{ fieldData.label[selectedLanguage] }}
        </label>
        <b-col cols="12" class="text-left">
          <b-form-group
            :id="fieldData.id"
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :description="fieldData.helperTextFirst[selectedLanguage]"
            :invalid-feedback="
              fieldData.validationMessageFirstSelect[selectedLanguage]
            "
          >
            <label>
              <span
                v-if="
                  fieldData.validation &&
                    fieldData.validation.requiredFirstSelect == 1
                "
                class="required-span"
                >*</span
              >
              {{ fieldData.labelFirst[selectedLanguage] }}
            </label>

            <v-select
              :disabled="isDisabled == 1"
              :searchable="fieldData.configuration.isLiveSearchable"
              :clearable="fieldData.configuration.isClearable"
              :multiple="fieldData.configuration.isMultipleSelect"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              :options="firstSelect"
              label="divisionName"
              value="index"
              v-model="selected"
              @input="selectOption"
              @option:deselected="filterFirstOption"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :description="fieldData.helperTextSeconed[selectedLanguage]"
            :invalid-feedback="
              fieldData.validationMessageSeconedSelect[selectedLanguage]
            "
          >
            <label>
              <span
                v-if="
                  fieldData.validation &&
                    fieldData.validation.requiredSeconedSelect == 1
                "
                class="required-span"
                >*</span
              >
              {{ fieldData.labelSeconed[selectedLanguage] }}
            </label>
            <v-select
              :disabled="isDisabled == 1"
              :searchable="fieldData.configuration.isLiveSearchableSecond"
              :clearable="fieldData.configuration.isClearableSecond"
              :multiple="fieldData.configuration.isMultipleSelectSecond"
              :options="secondSelect"
              v-model="secondSelected"
              @input="selectOptionTwo"
              label="subDivisionName"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              @option:deselected="filterSecondOptions"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :description="fieldData.helperTextThird[selectedLanguage]"
            :invalid-feedback="
              fieldData.validationMessageThirdSelect[selectedLanguage]
            "
          >
            <label>
              <span
                v-if="
                  fieldData.validation &&
                    fieldData.validation.requiredThirdSelect == 1
                "
                class="required-span"
                >*</span
              >
              {{ fieldData.labelThird[selectedLanguage] }}
            </label>
            <v-select
              :disabled="isDisabled == 1"
              label="groupName"
              :searchable="fieldData.configuration.isLiveSearchableThird"
              :clearable="fieldData.configuration.isClearableThird"
              :multiple="fieldData.configuration.isMultipleSelectThird"
              :options="thirdSelect"
              v-model="thirdSelected"
              @input="selectOptionThird"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- advance settings tab -->

      <b-modal
        cancel-title="Close"
        ok-title="Save"
        @ok="onSaveData"
        size="xl"
        v-model="showSettings"
        title="Combo select settings"
        no-close-on-esc
        no-close-on-backdrop
      >
        <AdvanceSelectSettings
          v-if="showSettings"
          :fieldData="fieldData"
          v-on:toggle-field="showSettings = !showSettings"
          v-on:update-form-settings="getData"
          @label-text="label = $event"
          @helper-text="helperText = $event"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import industriesRiskRatings from "../../utils/industryRiskRatings.json";
import vSelect from "vue-select";
import MenuButtons from "../menuButtons";
import AdvanceSelectSettings from "../advanceComboSelectSettingsComponent.vue";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import { ValidateSections } from "../../helpers";
import { Helper } from "../../helpers";
import _ from "lodash";

export default {
  name: "ComboSelectProgressiveGroup",
  components: {
    MenuButtons,
    AdvanceSelectSettings,
    vSelect,
  },
  data() {
    return {
      firstSelect: industriesRiskRatings.industries,
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: undefined,
      labelFirst: undefined,
      labelSeconed: undefined,
      helperTextFirst: undefined,
      helperTextSeconed: undefined,
      isRequireFirstSelect: 1,
      isRequireSeconedSelect: 1,
      name: "",
      Selected: [],
      secondSelect: [],
      secondSelected: [],
      thirdSelect: [],
      thirdSelected: [],
      selected: null,
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage", "userFormSubmitArray"]),
    ...mapState(["toggleAllCoppalse"]),
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          (this.fieldData.validation &&
            this.fieldData.validation.requiredFirstSelect == 1,
          this.fieldData.validation.requiredSeconedSelect == 1,
          this.fieldData.validation.requiredThirdSelect == 1)
        ) {
          if (this.fieldData.configuration.isMultipleSelectSecond) {
            if (
              this.selected &&
              this.secondSelected.length > 0 &&
              this.thirdSelected.length > 0
            ) {
              this.$store.state.validFields = true;
              this.fieldData.isInValid = false;
            } else {
              this.isFocus = true;
              this.$store.state.validFields = false;
              this.fieldData.isInValid = true;
            }
          } else if (!this.fieldData.configuration.isMultipleSelectSecond) {
            if (this.selected && this.secondSelected && this.thirdSelected) {
              this.$store.state.validFields = true;
              this.fieldData.isInValid = false;
            } else {
              this.isFocus = true;
              this.$store.state.validFields = false;
              this.fieldData.isInValid = true;
            }
          }
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id);
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },
  },

  mounted() {
    this.isRequireFirstSelect = this.fieldData.validation.requiredFirstSelect;
    this.isRequireSeconedSelect = this.fieldData.validation.requiredSeconedSelect;
    this.requiredThirdSelect = this.fieldData.validation.requiredThirdSelect;
    this.selected = this.fieldData.selected || null;
    this.secondSelected = this.fieldData.selectedTwo || null;
    this.thirdSelected = this.fieldData.selectedThird || null;

    if (this.$route.name == "userform") {
      this.setFieldValue();
    }
  },

  methods: {
    getData(data) {
      this.$emit("update-form-settings", data);
    },

    filterFirstOption(selectedDiv) {
      let secondArray = _.clone(this.secondSelected),
        thirdArray = _.clone(this.thirdSelected),
        filteredSubDivs = [],
        filteredGroups = [];

      // extract division name from dropdown select
      // const selectedDiv = _.find(value, "divisionName");
      if (selectedDiv) {
        // filtering sub divisions
        if (secondArray && secondArray.length) {
          filteredSubDivs = _.remove(secondArray, function(n) {
            return n.divisionName !== selectedDiv.divisionName;
          });
          this.secondSelected = filteredSubDivs;
        }
        // filtering groups
        if (thirdArray && thirdArray.length) {
          filteredGroups = _.remove(thirdArray, function(n) {
            return n.divisionName !== selectedDiv.divisionName;
          });
        }
        this.thirdSelected = filteredGroups;
      }
    },

    filterSecondOptions(selectedDiv){
      // console.log("filterSecondOptions", selectedDiv)
       let thirdArray = _.clone(this.thirdSelected),
        filteredGroups = [];

      // extract division name from dropdown select
      // const selectedDiv = _.find(value, "divisionName");
      if (selectedDiv) {
  
        // filtering groups
        if (thirdArray && thirdArray.length) {
          filteredGroups = _.remove(thirdArray, function(n) {
            return n.subDivisionName !== selectedDiv.subDivisionName;
          });
        }
        this.thirdSelected = filteredGroups;
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.map((el) => {
                // console.log("setFieldValue combo select pr", el.postValue.comboSelectTwo.find(di=>di));
                // console.log("setFieldValue combo select pr", el);
                if (_.isArray(el.postValue.comboSelectOne)) {
                  let comb2 = el.postValue.comboSelectOne.find((di) => di);
                  this.secondSelect = comb2.subDivisions;
                }
                if (_.isArray(el.postValue.comboSelectTwo)) {
                  let comb3 = el.postValue.comboSelectTwo.find((di) => di);
                  this.thirdSelect = comb3.groups;
                }
                this.selected = el.postValue.comboSelectOne;
                this.secondSelected = el.postValue.comboSelectTwo;
                this.thirdSelected = el.postValue.comboSelectThird
                  ? el.postValue.comboSelectThird
                  : [];
              });
            }
          }
        });
      this.setValue(this.fieldData.id);
    },

    selectOption(value) {
      // console.log("value", value);

      this.secondSelect = [];

      let isArray = _.isArray(value);
      if (isArray) {
        // this.secondSelect = [];

        if (value.length) {
          this.selected = value;
          for (let division of value) {
            if (division && division.subDivisions.length) {
              for (let SubDivision of division.subDivisions) {
                if (SubDivision) {
                  this.secondSelect.push(SubDivision);
                }
              }
            }
          }
        } else {
          this.resetSelections();
        }
      } else {
        if (value) {
          this.selected = (value && value.divisionName) || null;
          this.secondSelect = (value && value.subDivisions) || [];
          EventBus.$emit("refreshProductList", "singleSelect");
        } else {
          this.resetSelections();
        }
      }

      // console.log("secnd select selected", filterThirdArray);
      // console.log("third thirdSelected selected", this.thirdSelected);
    },

    checkForSubdivisions(val) {
      // console.log("secon select selected", val.divisionName);
      // let tt = _.findIndex(this.secondSelected, function (o) {
      //   return o.divisionName == val.divisionName;
      // });
      // let tt = _.find(this.secondSelected, function(o) { return o.divisionName != val.divisionName; });
      let oo = _.findIndex(this.secondSelected, function(t) {
        return t.divisionName == val.divisionName;
      });
      if (oo != -1) {
        // console.log("tt", oo)
        // let tt = _.find(this.secondSelected, function(o) { return o.divisionName == val.divisionName; });
        // let y = [];
        // y.push(this.secondSelected[oo])
        // console.log("y",tt)
        let evens = _.remove(this.secondSelected, function(n) {
          return n.divisionName != val.divisionName;
        });
        console.log("oo", evens);
      }
    },

    selectOptionTwo(value) {
      // console.log("selectOptionTwo", value);
      this.thirdSelect = [];
      let isArray = _.isArray(value);
      if (isArray) {
        if (value.length) {
          this.secondSelected = value;
          for (let subDivision of value) {
            if (subDivision && subDivision.groups.length) {
              for (let group of subDivision.groups) {
                if (group) {
                  this.thirdSelect.push(group);
                }
              }
            }
          }
          this.setValue();
          EventBus.$emit("refreshProductList", value.length);
        } else {
          this.thirdSelected = null;
          EventBus.$emit("refreshProductList", value.length);
        }
      } else {
        this.secondSelected = (value && value.subDivisionName) || null;
        this.thirdSelect = (value && value.groups) || [];
        this.setValue();
        EventBus.$emit("refreshProductList", "singleSelect");
      }
    },

    selectOptionThird(value) {
      // console.log("selectOptionThird", value);
      this.thirdSelected = value;
      this.setValue();
      EventBus.$emit("refreshProductList", value.length);
    },

    resetSelections() {
      this.selected = null;
      this.secondSelected = null;
      this.thirdSelected = null;
      this.secondSelect = [];
      this.thirdSelect = [];
      EventBus.$emit("refreshProductList", 0);
    },

    sectionCondition(selectedGrp) {
      console.log("selectedCtr");
      // for section conditions
      let sections = this.form1.formSection;
      let elements = this.form1.formSection[this.sectionIndex].formElements;

      let sectionSeven = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] ==
          "Services/Goods (Additional Question)"
      );

      let sectionFour = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Business Operations"
      );

      let sectionSix = sections.find(
        (sec) =>
          sec.sectionTitle[this.selectedLanguage] == "Details of Services/Goods"
      );

      // let groupCountr = this.thirdSelected.find(
      //   (ctr) => ctr.riskRating == 16
      // );

      // if (sectionFour && sectionSix && sectionSeven) {
      //   ValidateSections.validateSection(
      //     this.$store.state,
      //     sectionFour,
      //     sectionSix,
      //     sectionSeven
      //   );
      // }

      // console.log("indigenousCountr 1", indigenousCountr);
    },

    setValue(e) {
      // console.log("userFormSubmitArray 1", this.userFormSubmitArray);
      const registerData = _.clone(this.$store.state.registerData);

      if (this.$route.name == "userform") {
        if (this.secondSelected) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        this.$store.state.progressValue = numkeys;

        if (this.thirdSelected && this.thirdSelected.length) {
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              // console.log("thirdSelected---------")
              let xMaxScore = Math.max(
                ...Array.from(this.thirdSelected, (o) => o.riskRating)
              ); // to calculate max risk score
              console.log("xMax", xMaxScore);
              a.elements[0] = {
                isMultipleSelectFirst: this.fieldData.configuration
                  .isMultipleSelect,
                isMultipleSelectSecond: this.fieldData.configuration
                  .isMultipleSelectSecond,
                isMultipleSelectThird: this.fieldData.configuration
                  .isMultipleSelectThird,
                postValue: {
                  comboSelectOne: this.selected,
                  comboSelectTwo: this.secondSelected,
                  comboSelectThird: this.thirdSelected,
                },
                labels: {
                  comboSelectOneLabel: this.fieldData.labelFirst[
                    this.selectedLanguage
                  ],
                  comboSelectTwoLabel: this.fieldData.labelSeconed[
                    this.selectedLanguage
                  ],
                  comboSelectThirdLabel: this.fieldData.labelThird[
                    this.selectedLanguage
                  ],
                },
                score: xMaxScore || 0,
                postName: {
                  postNameComboSelectOne:
                    (this.fieldData.attributes &&
                      this.fieldData.attributes.postName) ||
                    "postNameComboSelectOne",
                  postNameComboSelectTwo:
                    (this.fieldData.attributes &&
                      this.fieldData.attributes.postName) ||
                    "comboSelectTwo",
                  postNameComboSelectThird:
                    (this.fieldData.attributes &&
                      this.fieldData.attributes.postName) ||
                    "comboSelectThird",
                },
              };
              this.sectionCondition(this.thirdSelected);
            }
          });
        }
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings Updated");
    },
  },

  validations: {
    selected: {
      required,
    },
    secondSelected: {
      required,
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: white !important;
}
</style>
